import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { API_URL, useAxios } from "../../../../../utils/const";
import { useToast } from "../../../../../Context/ToastContext";
import { useForm } from "react-hook-form";
import { Message } from "primereact/message";

const UploadLogbookModal = ({ toggleModal, getCourseSession, student }) => {
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: student.student[0].id,
    },
  });

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);

    const data = {
      id: formData.id,
      file: formData.file[0],
    };

    const fileData = new FormData();
    fileData.append("data", JSON.stringify(data));
    fileData.append("file", formData.file[0]);

    try {
      await axiosInstance.put(
        `${API_URL}/course-attendances/student/upload-logbook/${formData.id}`,
        fileData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      getCourseSession();
      setLoading(false);
      setToastObj({ msg: "Data Berhasil ditambahkan", type: "success" });
      closeModal();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Upload Logbook</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Upload Logbook</label>
          <input
            {...register("file", {
              required: "File tidak boleh kosong!",
              validate: (file) => {
                if (file && file[0]) {
                  const isPDF = file[0].type === "application/pdf";
                  if (!isPDF) {
                    return "File harus berformat PDF!";
                  }
                  if (file[0].size > 10 * 1024 * 1024) {
                    return "Ukuran file maksimal 10MB!";
                  }
                }
                return true;
              },
            })}
            type="file"
            className="form-control"
            accept=".pdf"
          />
          {errors.file && (
            <div className="">
              <Message
                className="mt-2 d-flex"
                severity="error"
                text={errors.file.message}
              />
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleSave)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Simpan</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadLogbookModal;
